import React from 'react'
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

const EachSide = ({eachSide, changeField}) => {
  return (
    <div className="additionalOptionItem">
      <div style={{width:'5%', marginLeft: 15, display: 'flex', alignItems: 'center'}}>
        <FormControlLabel
          control={
            <Checkbox
              checked={eachSide}
              onChange={(e) => changeField(e.target.checked)}
              value=""
            />
          }
        />
      </div>
      <div style={{width:'95%'}}>
        <p>
          <b>Each Side:</b>
          <span className="italics"> Select when you want this exercise to be performed on both sides.</span>
        </p>
      </div>
    </div>

  )
}

export default EachSide;



// WEBPACK FOOTER //
// ./src/components/workouts/inputs/EachSide.js